import { ActionTypes as CreateCitationActionTypes } from '../createCitation/constants'
import { ActionTypes, ValidatorStates } from './constants'
import { AddRemoveCitationInProgress, CitationState } from './types'

/**
 * Citation that we are looking to make.
 *
 * Eval: citation being created
 * Form (new): citation being created
 * Form (manual): citation being edited
 * Bib: citation selected for modals (InText citation | Footnote) or for copy
 *
 * Used on: Eval, Form, and Bibliography pages.
 */

const initialState: CitationState = {
  isNew: false,
  validatorStatus: ValidatorStates.COMPLETE,
  activeCitation: {},
  citationInProgress: [],
  showErrorToast: false,
}

export const citationReducer = (state = initialState, action): CitationState => {
  switch (action.type) {
    case CreateCitationActionTypes.SOURCE_SELECTION_COMPLETED:
      return {
        ...state,
        activeCitation: action.payload.selectedSource.data,
        autociteRioTrackingID: action.payload.selectedSource.autociteRioTrackingID,
        autociteResponseForRio: action.payload.selectedSource.autociteResponseForRio,
      }
    case ActionTypes.CITATION_VALIDATED:
      return {
        ...state,
        validatorStatus: action.payload.validatorStatus,
      }
    case ActionTypes.CITATION_UPDATE_SUCCEEDED:
    case ActionTypes.CITATION_LOAD:
      return {
        ...state,
        activeCitation: action.payload.citation,
        autociteRioTrackingID: action.payload.autociteRioTrackingID,
        autociteResponseForRio: action.payload.autociteResponseForRio,
      }
    case ActionTypes.CITATION_REVIEW:
      return {
        ...state,
        activeCitation: action.payload.citation,
      }
    case ActionTypes.SOURCE_SEARCHED:
    case ActionTypes.CITATION_CREATE_SUCCEEDED:
      return {
        ...state,
        isNew: true,
        activeCitation: action.payload.citation,
      }
    case ActionTypes.IGNORE_INCOMPLETE_CITATION:
      return {
        ...state,
        validatorStatus: ValidatorStates.IGNORED,
      }
    case ActionTypes.CITATION_CREATE_IN_PROGRESS: {
      let citationInProgressList = [...state.citationInProgress]
      if (action.payload.addRemoveCitationInProgress === AddRemoveCitationInProgress.ADD)
        citationInProgressList.push(action.payload.index)
      else if (
        action.payload.addRemoveCitationInProgress ===
        AddRemoveCitationInProgress.REMOVE_ALL
      )
        citationInProgressList = []
      else
        citationInProgressList.splice(
          citationInProgressList.indexOf(action.payload.index),
          1
        )
      return {
        ...state,
        citationInProgress: citationInProgressList,
      }
    }
    case ActionTypes.ADD_AUTOCITE_METADATA:
      return {
        ...state,
        autociteRioTrackingID: action.payload.autociteRioTrackingID,
        autociteResponseForRio: action.payload.autociteResponseForRio,
      }
    case ActionTypes.SHOW_ERROR_TOAST:
      return {
        ...state,
        showErrorToast: action.payload.showErrorToast,
      }
    default:
      return state
  }
}

export default citationReducer
